var exports = {
  "k": "xdbfd91f1--dab6bb--container",
  "D": "xdbfd91f1--dab6bb--title",
};

module.exports = exports;
